import styled from "styled-components";

export const AppBox = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  justify-content: space-evenly;
  align-content: space-evenly;
  row-gap: 30px;
  column-gap: 60px;
  padding: 40px;

`;

export const AppBoxButton = styled.div`
  padding: 8px;
  margin-top: auto;
  background-color: black;
  color: white;
  font-size: bold;
  width: 100%;
  text-align: center;
  &:hover {
    font-family: Consolas, monospace;
    font-weight: heavy;
  }
`;

export const AppBoxChild = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 6px -6px black;
  height: 315px; 
  background-color: white;
  overflow: hidden;
  cursor: pointer;
  &:hover {
    height: 320px;
    font-family: Consolas, monospace;
  }
  &:hover ${AppBoxButton} {
    // background-color: #de7b85;
    background-color:  #1A2D5D
  }
  border-radius: 15px;
`;

export const AppBoxChildHeadline = styled.div`
  margin: 0% auto;
  padding: 8px;
  font-size: 1.2em;
  font-weight: bold;
`;

export const AppBoxChildDetails = styled.div`
  padding: 8px;
  text-align: center;
  color: gray;
`;

export const AppBoxImage = styled.img`
  width: 100%;
  height: 220px; 
  object-fit: cover;
  border-radius: 15px 15px 0 0;
`;